//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './RepairsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetRepairsQueryParameters = {
  incomingNumber?: string | undefined ;
  article?: string | undefined ;
  serialNumber?: string | undefined ;
  selectedStatuses?: string[] | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
  language?: string | undefined ;
}

export type GetRepairOrdersForPdfGenerationRepairsQueryParameters = {
  search?: string | undefined ;
}

export type GetDetailsByIncomingNumberRepairsQueryParameters = {
  incomingNumber: string ;
  language?: string | undefined ;
}

export function getUrl(incomingNumber?: string | undefined, article?: string | undefined, serialNumber?: string | undefined, selectedStatuses?: string[] | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/repairs?";
if (incomingNumber === null)
    throw new Error("The parameter 'incomingNumber' cannot be null.");
else if (incomingNumber !== undefined)
    url_ += "IncomingNumber=" + encodeURIComponent("" + incomingNumber) + "&";
if (article === null)
    throw new Error("The parameter 'article' cannot be null.");
else if (article !== undefined)
    url_ += "Article=" + encodeURIComponent("" + article) + "&";
if (serialNumber === null)
    throw new Error("The parameter 'serialNumber' cannot be null.");
else if (serialNumber !== undefined)
    url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
if (selectedStatuses === null)
    throw new Error("The parameter 'selectedStatuses' cannot be null.");
else if (selectedStatuses !== undefined)
    selectedStatuses && selectedStatuses.forEach(item => { url_ += "SelectedStatuses=" + encodeURIComponent("" + item) + "&"; });
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
if (language === null)
    throw new Error("The parameter 'language' cannot be null.");
else if (language !== undefined)
    url_ += "language=" + encodeURIComponent("" + language) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.RepairsResponseDto, unknown, Types.RepairsResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RepairsResponseDto, unknown, Types.RepairsResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetRepairsQueryParameters): QueryKey;
export function getQueryKey(incomingNumber?: string | undefined, article?: string | undefined, serialNumber?: string | undefined, selectedStatuses?: string[] | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { incomingNumber, article, serialNumber, selectedStatuses, offset, limit, sortBy, sortOrder, language,  } = params[0] as GetRepairsQueryParameters;

    return trimArrayEnd([
        'RepairsClient',
        'get',
        incomingNumber as any,
        article as any,
        serialNumber as any,
        selectedStatuses as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
        language as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,       context.queryKey[5] as string[] | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as Types.SortOrder | undefined,       context.queryKey[10] as string | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.RepairsResponseDto, TError = unknown>(dto: GetRepairsQueryParameters, options?: Omit<UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param incomingNumber (optional) 
 * @param article (optional) 
 * @param serialNumber (optional) 
 * @param selectedStatuses (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function useGetQuery<TSelectData = Types.RepairsResponseDto, TError = unknown>(incomingNumber?: string | undefined, article?: string | undefined, serialNumber?: string | undefined, selectedStatuses?: string[] | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined, options?: Omit<UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.RepairsResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let incomingNumber: any = undefined;
  let article: any = undefined;
  let serialNumber: any = undefined;
  let selectedStatuses: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  let language: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ incomingNumber, article, serialNumber, selectedStatuses, offset, limit, sortBy, sortOrder, language,  } = params[0] as GetRepairsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [incomingNumber, article, serialNumber, selectedStatuses, offset, limit, sortBy, sortOrder, language, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RepairsResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(incomingNumber, article, serialNumber, selectedStatuses, offset, limit, sortBy, sortOrder, language),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param incomingNumber (optional) 
 * @param article (optional) 
 * @param serialNumber (optional) 
 * @param selectedStatuses (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.RepairsResponseDto | undefined) => Types.RepairsResponseDto, incomingNumber?: string | undefined, article?: string | undefined, serialNumber?: string | undefined, selectedStatuses?: string[] | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined) {
  queryClient.setQueryData(getQueryKey(incomingNumber, article, serialNumber, selectedStatuses, offset, limit, sortBy, sortOrder, language),
    updater
  );
}

/**
 * Gets data.
 * @param incomingNumber (optional) 
 * @param article (optional) 
 * @param serialNumber (optional) 
 * @param selectedStatuses (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RepairsResponseDto | undefined) => Types.RepairsResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getRepairOrdersForPdfGenerationUrl(search?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/repairs/pdf-generation-list?";
if (search === null)
    throw new Error("The parameter 'search' cannot be null.");
else if (search !== undefined)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getRepairOrdersForPdfGenerationDefaultOptions: Omit<UseQueryOptions<Types.RepairsResponseDto, unknown, Types.RepairsResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RepairsResponseDto, unknown, Types.RepairsResponseDto>, 'queryFn'>> = {
};
export function getGetRepairOrdersForPdfGenerationDefaultOptions() {
  return getRepairOrdersForPdfGenerationDefaultOptions;
};
export function setGetRepairOrdersForPdfGenerationDefaultOptions(options: typeof getRepairOrdersForPdfGenerationDefaultOptions) {
  getRepairOrdersForPdfGenerationDefaultOptions = options;
}

export function getRepairOrdersForPdfGenerationQueryKey(search?: string | undefined): QueryKey;
export function getRepairOrdersForPdfGenerationQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search,  } = params[0] as GetRepairOrdersForPdfGenerationRepairsQueryParameters;

    return trimArrayEnd([
        'RepairsClient',
        'getRepairOrdersForPdfGeneration',
        search as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsClient',
        'getRepairOrdersForPdfGeneration',
        ...params
      ]);
  }
}
export function __getRepairOrdersForPdfGeneration(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getRepairOrdersForPdfGeneration(
      context.queryKey[2] as string | undefined,axiosConfig    );
}

export function useGetRepairOrdersForPdfGenerationQuery<TSelectData = Types.RepairsResponseDto, TError = unknown>(dto: GetRepairOrdersForPdfGenerationRepairsQueryParameters, options?: Omit<UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Searches repair orders that have been created or entered.
 * @param search (optional) 
 */
export function useGetRepairOrdersForPdfGenerationQuery<TSelectData = Types.RepairsResponseDto, TError = unknown>(search?: string | undefined, options?: Omit<UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetRepairOrdersForPdfGenerationQuery<TSelectData = Types.RepairsResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search,  } = params[0] as GetRepairOrdersForPdfGenerationRepairsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RepairsResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getRepairOrdersForPdfGeneration(context, axiosConfig) : __getRepairOrdersForPdfGeneration,
    queryKey: getRepairOrdersForPdfGenerationQueryKey(search),
    ...getRepairOrdersForPdfGenerationDefaultOptions as unknown as Omit<UseQueryOptions<Types.RepairsResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Searches repair orders that have been created or entered.
 * @param search (optional) 
 */
export function setGetRepairOrdersForPdfGenerationData(queryClient: QueryClient, updater: (data: Types.RepairsResponseDto | undefined) => Types.RepairsResponseDto, search?: string | undefined) {
  queryClient.setQueryData(getRepairOrdersForPdfGenerationQueryKey(search),
    updater
  );
}

/**
 * Searches repair orders that have been created or entered.
 * @param search (optional) 
 */
export function setGetRepairOrdersForPdfGenerationDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RepairsResponseDto | undefined) => Types.RepairsResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getDetailsByIncomingNumberUrl(incomingNumber: string, language?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/repairs/details/{incomingNumber}?";
if (incomingNumber === undefined || incomingNumber === null)
  throw new Error("The parameter 'incomingNumber' must be defined.");
url_ = url_.replace("{incomingNumber}", encodeURIComponent("" + incomingNumber));
if (language === null)
    throw new Error("The parameter 'language' cannot be null.");
else if (language !== undefined)
    url_ += "language=" + encodeURIComponent("" + language) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDetailsByIncomingNumberDefaultOptions: Omit<UseQueryOptions<Types.RepairsDetailsDto, unknown, Types.RepairsDetailsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RepairsDetailsDto, unknown, Types.RepairsDetailsDto>, 'queryFn'>> = {
};
export function getGetDetailsByIncomingNumberDefaultOptions() {
  return getDetailsByIncomingNumberDefaultOptions;
};
export function setGetDetailsByIncomingNumberDefaultOptions(options: typeof getDetailsByIncomingNumberDefaultOptions) {
  getDetailsByIncomingNumberDefaultOptions = options;
}

export function getDetailsByIncomingNumberQueryKey(dto: GetDetailsByIncomingNumberRepairsQueryParameters): QueryKey;
export function getDetailsByIncomingNumberQueryKey(incomingNumber: string, language?: string | undefined): QueryKey;
export function getDetailsByIncomingNumberQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { incomingNumber, language,  } = params[0] as GetDetailsByIncomingNumberRepairsQueryParameters;

    return trimArrayEnd([
        'RepairsClient',
        'getDetailsByIncomingNumber',
        incomingNumber as any,
        language as any,
      ]);
  } else {
    return trimArrayEnd([
        'RepairsClient',
        'getDetailsByIncomingNumber',
        ...params
      ]);
  }
}
export function __getDetailsByIncomingNumber(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDetailsByIncomingNumber(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useGetDetailsByIncomingNumberQuery<TSelectData = Types.RepairsDetailsDto, TError = unknown>(dto: GetDetailsByIncomingNumberRepairsQueryParameters, options?: Omit<UseQueryOptions<Types.RepairsDetailsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get Details By Incoming Number.
 * @param language (optional) 
 */
export function useGetDetailsByIncomingNumberQuery<TSelectData = Types.RepairsDetailsDto, TError = unknown>(incomingNumber: string, language?: string | undefined, options?: Omit<UseQueryOptions<Types.RepairsDetailsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDetailsByIncomingNumberQuery<TSelectData = Types.RepairsDetailsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RepairsDetailsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let incomingNumber: any = undefined;
  let language: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ incomingNumber, language,  } = params[0] as GetDetailsByIncomingNumberRepairsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [incomingNumber, language, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RepairsDetailsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDetailsByIncomingNumber(context, axiosConfig) : __getDetailsByIncomingNumber,
    queryKey: getDetailsByIncomingNumberQueryKey(incomingNumber, language),
    ...getDetailsByIncomingNumberDefaultOptions as unknown as Omit<UseQueryOptions<Types.RepairsDetailsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get Details By Incoming Number.
 * @param language (optional) 
 */
export function setGetDetailsByIncomingNumberData(queryClient: QueryClient, updater: (data: Types.RepairsDetailsDto | undefined) => Types.RepairsDetailsDto, incomingNumber: string, language?: string | undefined) {
  queryClient.setQueryData(getDetailsByIncomingNumberQueryKey(incomingNumber, language),
    updater
  );
}

/**
 * Get Details By Incoming Number.
 * @param language (optional) 
 */
export function setGetDetailsByIncomingNumberDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RepairsDetailsDto | undefined) => Types.RepairsDetailsDto) {
  queryClient.setQueryData(queryKey, updater);
}